import { Stack, Typography, styled } from "@mui/material"
import {
  EvolutionStatChip,
  formatPrice,
  isDefined,
} from "@pharmupp/p3-front-commons"
import type { ReactNode } from "react"
import { CardLayout } from "./components"

interface ActivityCardProps {
  Icons: ReactNode
  title: string
  subTitle: string
  mainStat?: number | null
  isMainStatPrice?: boolean
  evolution?: number | null
  globalEvolution?: number | null
}

export const ActivityCard = ({
  Icons,
  title,
  subTitle,
  mainStat,
  evolution,
  globalEvolution,
  isMainStatPrice,
}: ActivityCardProps) => {
  return (
    <CardLayout>
      {Icons}

      <RowLayout>
        <Title>{title}</Title>
        <RowEvol>
          <MainStat mainStat={mainStat} isPrice={isMainStatPrice} />
          {isDefined(evolution) && <EvolutionChip bold evol={evolution} />}
        </RowEvol>
      </RowLayout>

      <RowLayout mt={0.5}>
        <SubTitle>{subTitle}</SubTitle>
        <RowEvol sx={{ color: (t) => t.palette.grey.light, typography: "12px" }}>
          Evol.PharmUPP{" "}
          {isDefined(globalEvolution) ? (
            <EvolutionChip isNeutral evol={globalEvolution} />
          ) : (
            "-"
          )}
        </RowEvol>
      </RowLayout>
    </CardLayout>
  )
}

const MainStat = ({
  mainStat,
  isPrice,
}: { mainStat?: number | null; isPrice?: boolean }) => (
  <Typography
    variant="14px"
    fontWeight={600}
    sx={{ color: (t) => t.palette.text.primary }}
  >
    {isPrice ? (
      <>
        {isDefined(mainStat) ? formatPrice(mainStat) : "-"}{" "}
        <Typography variant="12px" fontWeight={500}>
          HT
        </Typography>
      </>
    ) : (
      mainStat
    )}
  </Typography>
)

const RowLayout = styled(Stack)(({ theme: { spacing } }) => ({
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  gap: spacing(1),
}))

const Title = styled(Typography)(({ theme: { palette } }) => ({
  color: palette.tertiary.dark1,
  fontWeight: 500,
}))
Title.defaultProps = {
  variant: "14px",
}
const SubTitle = styled(Typography)(({ theme: { palette } }) => ({
  color: palette.text.primary,
}))
SubTitle.defaultProps = {
  variant: "12px",
}
const RowEvol = styled(Stack)(({ theme: { spacing } }) => ({
  flexDirection: "row",
  alignItems: "center",
  gap: spacing(1),
}))

const EvolutionChip = styled(EvolutionStatChip)({})
EvolutionChip.defaultProps = {
  arrow: true,
  border: false,
}
